var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#6B8E76",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1739 18.812C33.7026 18.2834 33.9997 17.5665 33.9998 16.8189C33.9999 16.0713 33.703 15.3542 33.1744 14.8255C32.6459 14.2968 31.9289 13.9997 31.1813 13.9996C30.4337 13.9995 29.7166 14.2964 29.1879 14.825L15.8419 28.174C15.6098 28.4055 15.438 28.6905 15.3419 29.004L14.0209 33.356C13.9951 33.4425 13.9931 33.5344 14.0153 33.6219C14.0374 33.7094 14.0829 33.7892 14.1467 33.853C14.2106 33.9168 14.2906 33.9621 14.3781 33.9841C14.4656 34.0061 14.5575 34.004 14.6439 33.978L18.9969 32.658C19.3101 32.5628 19.5951 32.3921 19.8269 32.161L33.1739 18.812Z",
    stroke: "#6B8E76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 17L31 21",
    stroke: "#6B8E76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.aa2c99ac295f7c97aad822dd1d370c13.svg";
export { ForwardRef as ReactComponent };